import { DynamicInputOrSelect } from 'src/components/dynamic-input-select';

export default DynamicInputOrSelect;
